import React, { useRef } from 'react';
import toast from 'react-hot-toast';
import { PopupWraper } from 'components/popup';
import { Actions } from 'configs/actions';
import { Roles } from 'configs/roles';
import { Button } from 'modules';
import { useResendAccountActivationEmailMutation } from 'services/user/mutation/useResendAccountActivationEmailMutation';
import { normalizedPhoneNumber } from 'utils/helpers/helpers';
import {
  checkRolesIncludeRoles,
  checkValidActionRoleAdmin,
  getUserRoles,
} from 'utils/helpers/auth';
import { isRequestError } from 'utils/requestError';

type Props = { phoneNumber: string; onClose: () => void };

const ResendActivationEmail = ({ phoneNumber, onClose }: Props) => {
  const sending = useRef(false);
  const { mutateAsync, isLoading } = useResendAccountActivationEmailMutation();
  const accountPhone = normalizedPhoneNumber(phoneNumber?.trim() || '');

  const close = () => {
    if (!sending.current) onClose();
  };

  const resend = async () => {
    if (!accountPhone || sending.current) return;
    if (
      !checkRolesIncludeRoles(getUserRoles(), [
        Roles.SUPER_ADMIN,
        Roles.ADMIN,
      ]) ||
      !checkValidActionRoleAdmin(Actions.ManageUser_ResendAccountActivationMail)
    ) {
      toast.error('Bạn không có quyền gửi lại mail kích hoạt');
      onClose();
      return;
    }
    sending.current = true;
    try {
      const response = await mutateAsync({ phoneNumber: accountPhone });
      if (response.statusCode < 200 || response.statusCode >= 300) {
        toast.error(
          response.message?.join('\n') || 'Không thể gửi lại mail kích hoạt',
        );
        return;
      }
      toast.success(
        'Đã đưa mail kích hoạt vào hàng đợi gửi đến email đã lưu của tài khoản',
      );
      onClose();
    } catch (error) {
      if (!isRequestError(error))
        toast.error('Không thể gửi lại mail kích hoạt');
    } finally {
      sending.current = false;
    }
  };

  return (
    <PopupWraper center title='Gửi lại mail kích hoạt' onClose={close}>
      <div className='container'>
        Gửi lại mail kích hoạt cho SĐT <strong>{accountPhone}</strong> đến email
        đã lưu của tài khoản?
      </div>
      <div className='wrap-button-remove-user'>
        <Button
          label='Gửi lại mail'
          buttonType='success'
          onClick={resend}
          isLoading={isLoading}
          disabled={!accountPhone || isLoading}
        />
        <Button
          label='Hủy'
          buttonType='grey'
          onClick={close}
          disabled={isLoading}
        />
      </div>
    </PopupWraper>
  );
};

export default ResendActivationEmail;
